import React, { useState } from 'react';
import { Avatar, CardActionArea, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import {
  poppins400,
  poppins500,
  fontsize10,
  fontsize16,
} from 'theme/common.style';
import { themeGray } from 'theme/color';

const ActivityCard = ({ index, onPropertyClick }) => {
  const [hovered, setHovered] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userDetail'));

  return (
    <CardActionArea
      onClick={() =>
        onPropertyClick(
          index?.actPropertyId,
          index?.activityName,
          index?.binderId,
          index?.userId
        )
      }
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        border: '1px solid #D9D9D9',
        boxShadow: hovered ? '0 0 5px #c0bfbf' : 'none',
        padding: '12px 10px',
        borderRadius: '8px',
        minHeight: hovered ? 100 : 70,
        transition: 'all 0.45s cubic-bezier(0.4, 0, 0.2, 1)',
        marginBottom: '30px',
        overflow: 'hidden',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="flex-start">
        {/* Avatar */}
        <Avatar
          src={index?.profileImage || undefined}
          sx={{
            width: 36,
            height: 36,
            flexShrink: 0,
            bgcolor: index?.profileImage ? 'transparent' : '#666',
            fontSize: 16,
          }}
        >
          {!index?.profileImage &&
            `${userData?.userName?.[0] || ''}${
              userData?.userSurName?.[0] || ''
            }`}
        </Avatar>

        {/* Content */}
        <Grid sx={{ flex: 1, minWidth: 0 }}>
          {/* Title */}
          <Typography
            sx={{
              ...poppins500,
              ...fontsize16,
              color: '#112347',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: hovered ? 'unset' : 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {index?.activityName}
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              ...poppins400,
              ...fontsize10,
              color: themeGray,
              marginTop: '4px',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: hovered ? 'unset' : 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              marginBottom: '10px',
            }}
          >
            {index?.activity}
          </Typography>
        </Grid>
      </Stack>

      {/* Time */}
      <Typography
        sx={{
          ...poppins400,
          ...fontsize10,
          color: '#C4C4C4',
          position: 'absolute',
          right: '10px',
          bottom: '0px',
        }}
      >
        {index?.activityTime}
      </Typography>
    </CardActionArea>
  );
};

export default ActivityCard;
